import {ReactElement, useRef} from "react";
import LoadFuelPanel from "@/components/loadFuel/LoadFuelPanel";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {useGetFuelBalance} from "@/hooks/useGetFuelBalance";
import {Modal} from "@/widgets/Modal";
import {useGetUserProfile} from "@/hooks/useGetUserProfile";

interface Props {
    isOpen: boolean;
    size?: "xs" | "sm" | "md" | "lg" | "xl" | "xs2" | "sm2" | "xs1" | "max";
    toggle: () => void;
    onFuelLoaded?: () => void; // Callback after fuel is successfully loaded
}

function LoadFuelModal(props: Props): ReactElement {

    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: currentUser} = useGetUserProfile(fullToken);
    const {refetch: refetchTransactionData} = useGetFuelBalance(fullToken, currentUser?.user?.id);
    /* Set by the panel when a load completes; read on close. A ref, not state — nothing renders from it. */
    const loadedRef = useRef(false);

    if (!fullToken) {
        return null;
    }

    /*
     * The ONE close path — X, success dismiss, Escape and backdrop. Splitting
     * them let a close report a reload that never happened, and let a real one
     * go unreported. The panel decides what counts as loaded; this relays it.
     */
    const closeAndNotify = async (): Promise<void> => {
        props.toggle();
        await refetchTransactionData();
        if (loadedRef.current) {
            loadedRef.current = false;
            props.onFuelLoaded?.();
        }
    };

    return (
        <Modal
            isOpen={props.isOpen}
            toggle={() => void closeAndNotify()}
            contentClassName="contact-modal load-fuel-modal"
            size={props.size ?? "sm2"}
            ariaLabel="Load Fuel"
        >
            <LoadFuelPanel
                onFuelLoaded={() => {
                    loadedRef.current = true;
                }}
                toggleAsModal={closeAndNotify}
            />
        </Modal>
    );
}

export default LoadFuelModal;